var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransbankSuccessful(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 231,
    height: 231,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rect\\xE1ngulo 5466",
    transform: "translate(0 .027)",
    fill: "none",
    d: "M0 0h231v231H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17916"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17915",
    transform: "translate(0 -.027)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17910"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17909",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6725",
    d: "M230.862 115.594a115.431 115.431 0 1 0-115.431 115.431 115.431 115.431 0 0 0 115.431-115.431",
    fill: "#a8ce33"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17914"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17913",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6732",
    d: "m107.346 134.65-16.739 44.76 49.16 49.16A115.53 115.53 0 0 0 228.73 94.409l-37.757-37.467Z",
    fill: "#95b927"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6727",
    d: "m90.842 179.432-51.439-51.437a16.485 16.485 0 0 1 23.313-23.315l28.253 28.251 76.927-76.094a16.484 16.484 0 1 1 23.184 23.44Z",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransbankSuccessful);
export default __webpack_public_path__ + "static/media/transbank_successful.33883f7cc68bbc370da37bab1f4fd62b.svg";
export { ForwardRef as ReactComponent };